// AWS Verified Permissions (Cedar RBAC) per-stage config.
//
// The store is flexinet-directory-avp-infra's, one per shared services
// account. Its id comes from VITE_AVP_POLICY_STORE_ID in each .env.<mode>,
// found by the store's namespace with `get-schema`, never by its position:
// each account holds about a dozen unnamed stores.
//
// `enabled` is false while the id is blank, and the provider then asks AVP
// nothing and allows nothing.

const policyStoreId = import.meta.env.VITE_AVP_POLICY_STORE_ID ?? '';
const region = import.meta.env.VITE_AVP_REGION ?? import.meta.env.VITE_AWS_REGION ?? 'us-west-2';

// flexinet-directory-avp-infra's namespace, the same in every stage. Every
// request names its action as `<Namespace>::Action`: a policy scoped to one action names
// `<Namespace>::Action::"X"`, and Cedar never matches that against a bare
// `Action::"X"` (FNP-1657).
const namespace = 'FlexiNetDirectory';

const permissions = {
    enabled: policyStoreId.length > 0,
    policyStoreId,
    region,
    actionType: `${namespace}::Action`,
};

export default permissions;
